<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
  } from "sveltestrap";
  import { getContext } from "svelte";
  import { ListGroup, ListGroupItem, Spinner, Input } from "sveltestrap";
  import EditAllModal from "./EditAllModal.svelte";
  export let open;
  export let toggle;
  export let newdate;
  export let data;
  let prev_jobid = data.job;
  let prev_jobname = data.jobname;
  let prev_deliverableid = data.del;
  let prev_taskid = data.task;
  let prev_notes = data.note;
  let job = data.jobname;
  let deliverableid = data.id;
  let deliverablename = data.delname;
  let del_id = data.del;
  let taskname = data.taskname;
  let taskid = data.task;
  let note = data.note;
  let jobsArray = null;
  let job_id = data.job;
  let focus = true;
  let deliverableArray = null;
  let taskArray = null;
  let showDeliverable = false;
  let day = data.day;
  let hours = parseFloat(data.totalhours).toFixed(2);
  let staff = data.staff;
  let weekStart = data.weekStart;
  let activityid = data.activityid;
  let actualstart = data.actualstart;
  let timesheetId = data.timesheetId;
  let editviewtimesheet = null;
  let open_editall = false;
  let submitting = false;
  let error = false;
  let error_message = "";

  const toggle_editall = () => (open_editall = !open_editall);

  const { refreshTimesheet } = getContext('timesheet');

  async function getJobs() {
    const res = await fetch("/timesheetapi/BuildJob?prefixText=" + job);
    const json = await res.json();
    jobsArray = json;
  }

  async function getDeliverable(job_id) {
    const res = await fetch("/timesheetapi/BuildDeliverables?jobId=" + job_id);
    const json = await res.json();
    deliverableArray = json;
  }

  async function getTask(deliverable_id) {
    const res = await fetch(
      "/timesheetapi/BuildCostCenter?deliverableId=" + deliverable_id
    );
    const json = await res.json();
    taskArray = json;
  }

  async function saveEdit() {
    const edit_data = {
      JobId: job_id,
      JobName: job,
      TimesheetId: timesheetId,
      DeliverableId: del_id,
      TaskId: taskid,
      Notes: note,
      Hours: hours,
      Day: day,
      Prev_JobId: prev_jobid,
      Prev_JobName: prev_jobname,
      Prev_DeliverableId: prev_deliverableid,
      Prev_TaskId: prev_taskid,
      Prev_Notes: prev_notes,
      weekStart: newdate,
      StaffId: staff,
      ActivityId: activityid,
      Date: actualstart
    };
    const res = await fetch("/timesheetapi/EditTimeCard", {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(edit_data)
    });
    const json = await res.status;
    toggle();
    if (json === 200) {
      setTimeout(() => {
        refreshTimesheet();
        submitting = false;
      }, 100);
    }
  }

  async function EditViewTimesheet() {
    const res = await fetch(`timesheetapi/EditViewTimesheetDetails?timesheetId=${timesheetId}&note=${note}&deliverableId=${del_id}&jobId=${job_id}&costcentreId=${taskid}`);
    const json = await res.json();
    const status = await res.status;
    if (status === 200) {
      open_editall = true;
      editviewtimesheet = json;
    }
  }

  function handleChangeJob(e) {
    job = e.target.value;
    getJobs(job);
  }

  function handlePassId(id, name) {
    focus = false;
    job_id = id;
    job = name;
    showDeliverable = true;
    getDeliverable(id);
  }

  const onFocus = () => (focus = true);

  function handleSaveEdit() {
    if (hours > 24) {
      error = true;
      error_message = "Hours should not exceed to 24";
    } else {
      submitting = true;
      error = false;
      saveEdit();
    }
  }

  function handleCancel() {
    job = data.jobname;
    deliverableid = data.id;
    taskid = data.task;
    note = data.note;
    hours = parseFloat(data.totalhours).toFixed(2);
    toggle();
  }
  function handleChangeDeliverable(e) {
    deliverableid = e.target.value;
    getTask(deliverableid);
  }

  function handleChangeTask(e) {
    taskname = e.target.value;
  }

  function handleOpenEditAll() {
    toggle();
    EditViewTimesheet();
  }
</script>

<style>
  label {
    font-size: 18px;
    display: block;
    font-weight: 500;
  }
  select {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  .row-container {
    margin-bottom: 10px;
  }
  .btn-edit-all {
    border: 1px solid #0984e3;
    border-radius: 5px;
    color: #0984e3;
    background-color: white;
    padding: 5px 10px;
    margin-left: 10px;
  }
  .read-only-fields {
    background-color: #dcdde1 !important;
    cursor: not-allowed;
  }
</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>
    Edit
    <i>({day})</i>
    <button class="btn-edit-all" on:click={handleOpenEditAll}>Edit All</button>
  </ModalHeader>
  <ModalBody>
    <div class="edit-timesheet-modal-body">
      <div class="row-container">
        <label>Job</label>
        <input
          type="text"
          placeholder="Job"
          class="read-only-fields"
          value={job}
          on:keyup={handleChangeJob}
          on:focus={onFocus}
          disabled />
        <input type="text" value={job_id} hidden />
        {#if jobsArray !== null}
          {#if job !== ''}
            {#if focus}
              <!-- <div class="listgroup-style">
                <ListGroup>
                  {#each jobsArray as job}
                    <div class="listitem-style">
                      <ListGroupItem
                        tag="button"
                        action
                        key={job.jobId}
                        on:click={handlePassId(job.jobId, job.jobName)}>
                        {job.jobName}
                      </ListGroupItem>
                    </div>
                  {/each}
                </ListGroup>
              </div> -->
            {/if}
          {/if}
        {/if}
      </div>
      <div class="row-container">
        <label>Deliverable</label>
        <select
          value={deliverableid}
          on:change={handleChangeDeliverable}
          aria-readonly="true"
          class="read-only-fields">
          {#if deliverableArray !== null}
            {#each deliverableArray as deliverable}
              <option value={deliverable.deId}>{deliverable.deName}</option>
            {/each}
          {:else}
            <option value={deliverableid}>{deliverablename}</option>
          {/if}
        </select>
      </div>
      <div class="row-container">
        <label>Task</label>
        <select
          value={taskid}
          on:change={handleChangeTask}
          aria-readonly="true"
          class="read-only-fields">
          {#if taskArray !== null}
            {#each taskArray as task}
              <option value={task.costId}>{task.costName}</option>
            {/each}
          {:else}
            <option value={taskid}>{taskname}</option>
          {/if}
        </select>
      </div>
      <div class="row-container">
        <label>Notes</label>
        <Input type="textarea" style="margin-top: 13px;" bind:value={note} />
      </div>
      <div class="row-container">
        <label>Hours</label>
        <input
          type="number"
          style={error ? 'border: 1px solid red;' : ''}
          max="24"
          min="0"
          bind:value={hours} />
        {#if error}
          <p style="margin-left: 10px; color: red;">{error_message}</p>
        {/if}
      </div>
    </div>
  </ModalBody>
  <ModalFooter>
    {#if submitting}
      <Button
        color="primary"
        style="cursor: not-allowed; opacity: 0.5"
        on:click={handleSaveEdit}>
        <Spinner size="sm" />
        Saving
      </Button>
    {:else if hours === undefined}
      <Button
        color="primary"
        style="cursor: not-allowed; opacity: 0.5"
        disabled
        on:click={handleSaveEdit}>
        Save
      </Button>
    {:else}
      <Button color="primary" on:click={handleSaveEdit}>Save</Button>
    {/if}
    <Button color="secondary" on:click={handleCancel}>Cancel</Button>
  </ModalFooter>
</Modal>
{#if editviewtimesheet !== null}
  <EditAllModal
    open={open_editall}
    toggle={toggle_editall}
    data={editviewtimesheet}
    staffid={data.staff}
    edittoggle={toggle}
    {newdate} />
{/if}
